import React from 'react';
import { Award, TrendingUp, Shield, Star } from 'lucide-react';
import { achievements } from '../data/mock';
import CTAButtons from './CTAButtons';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const iconMap = {
  Award: Award,
  TrendingUp: TrendingUp,
  Shield: Shield,
  Star: Star
};

const Achievement = () => {
  const renderAchievementCard = (achievement, index) => {
    const Icon = iconMap[achievement.icon];
    return (
      <div key={index} className="bg-white/10 backdrop-blur-md rounded-2xl p-8 text-center hover:bg-white/20 transition-all duration-300 hover:-translate-y-2 h-full">
        <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon className="w-8 h-8 text-white" />
        </div>
        <h3 className="text-xl font-bold">{achievement.title}</h3>
      </div>
    );
  };

  return (
    <section className="py-24 bg-gradient-to-br from-blue-900 via-emerald-900 to-blue-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4xIj48cGF0aCBkPSJNMzYgMzBoMnYyaC0ydi0yem0wLThoMnYyaC0ydi0yem0wLTE2aDJ2MmgtMnYtMnptMCA4aDJ2MmgtMnYtMnptMCAxNmgydjJoLTJ2LTJ6bTAgOGgydjJoLTJ2LTJ6bTAtNDBoMnYyaC0ydi0yem0wIDhoMnYyaC0ydi0yem0wIDE2aDJ2MmgtMnYtMnptMCA4aDJ2MmgtMnYtMnoiLz48L2c+PC9nPjwvc3ZnPg==')]" />
      </div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-xl font-semibold">
            Achievement
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Our Achievement & Experience
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
            We pride ourselves on delivering exceptional results and protecting countless brands. With years of expertise and a track record of successful registrations, we are committed to helping businesses secure their identity with confidence.
          </p>
        </div>

        {/* Desktop Grid - Hidden on mobile/tablet */}
        <div className="hidden lg:grid grid-cols-4 gap-8 mb-12">
          {achievements.map((achievement, index) => renderAchievementCard(achievement, index))}
        </div>

        {/* Mobile/Tablet Slider - Hidden on desktop */}
        <div className="lg:hidden mb-12">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={20}
            pagination={{
              clickable: true,
              bulletClass: 'swiper-pagination-bullet !bg-white',
              bulletActiveClass: 'swiper-pagination-bullet-active'
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 20
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20
              }
            }}
            className="achievement-slider"
          >
            {achievements.map((achievement, index) => (
              <SwiperSlide key={index}>
                {renderAchievementCard(achievement, index)}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="text-center">
          <CTAButtons className="justify-center" variant="dark" />
        </div>
      </div>
    </section>
  );
};

export default Achievement;